import { Dispatch, MouseEvent, SetStateAction, useEffect, useRef, useState } from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useWindowSize } from '../hooks';
import * as Styled from '../styled';
import { defaults, DragNDropAndResizableType, ON_CHANGE_REASON } from '../types';

type UserScreenData = { t: number; l: number; w: number; h: number };

export const Header = ({
  startT,
  setStartL,
  setStartT,
  headerLeft,
  onClose,

  t,
  l,
  w,
  h,
  setT,
  setL,
  setW,
  setH,
  windowOnChange,
}: {
  startT?: number;
  setStartL: Dispatch<SetStateAction<number | undefined>>;
  setStartT: Dispatch<SetStateAction<number | undefined>>;
  headerLeft?: JSX.Element;
  onClose: (props?: any) => void;

  t: number;
  l: number;
  w: number;
  h: number;
  setT: Dispatch<SetStateAction<number>>;
  setL: Dispatch<SetStateAction<number>>;
  setW: Dispatch<SetStateAction<number>>;
  setH: Dispatch<SetStateAction<number>>;
  windowOnChange: DragNDropAndResizableType['onChange'];
}) => {
  const isMounted = useRef(false);
  const isMountedFullScreen = w >= window.innerWidth && h >= window.innerHeight;
  const [isFullScreen, setIsFullScreen] = useState(isMountedFullScreen);
  const [userScreenData, setUserScreenData] = useState<UserScreenData>(
    isMountedFullScreen
      ? { t: defaults.top, l: defaults.left, w: defaults.width, h: defaults.height }
      : ({} as UserScreenData)
  );
  const { width: windowWidth, height: windowHeight } = useWindowSize();
  const startMouseHeaderMove = (event: MouseEvent<HTMLElement>) => {
    if (isFullScreen) return;

    setStartT(event.clientY);
    setStartL(event.clientX);
  };

  const resolveFullScreen = () => {
    if (isFullScreen) {
      setT(userScreenData.t);
      setL(userScreenData.l);
      setW(userScreenData.w);
      setH(userScreenData.h);
      setIsFullScreen(false);

      return;
    }

    setUserScreenData({ t, l, w, h });
    setT(0);
    setL(0);
    setW(window.innerWidth);
    setH(window.innerHeight);
    setIsFullScreen(true);
  };

  const cursor = startT ? 'move' : 'inherit';

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    windowOnChange?.call(null, {
      top: t,
      left: l,
      width: w,
      height: h,
      changed: isFullScreen ? ON_CHANGE_REASON.TO_FULL_SCREEN : ON_CHANGE_REASON.FROM_FULL_SCREEN,
    });
  }, [isFullScreen]);

  useEffect(() => {
    if (!isFullScreen) return;

    setW(window.innerWidth);
    setH(window.innerHeight);
  }, [windowWidth, windowHeight]);

  return (
    <Styled.Header>
      <Styled.HeaderLeft style={{ cursor }} onMouseDown={startMouseHeaderMove}>
        {headerLeft}
      </Styled.HeaderLeft>

      <Styled.HeaderRight>
        <IconButton onClick={resolveFullScreen}>
          {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>

        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Styled.HeaderRight>
    </Styled.Header>
  );
};
